import { useState } from "react"

export const VoucherState = () => {
    const [results, setResults] = useState([]);
    const [showVoucherModal, setShowVoucherModal] = useState(false)
    const [voucherCode, setVoucherCode] = useState('')
    const [voucher, setVoucher] = useState('')
    const [voucherDetails, setVoucherDetails] = useState({createdDate: "", expirationDate: "", isExpired: "", formattedExpire: "", typeLabel: "", valueLabel: ""})
    const [snackBarLoader, setSnackBarLoader] = useState({snackbar:false, msg:'', type:''})
    const [voucherLoader, setVoucherLoader] = useState(false)


    return {
        results: {data: results, set: setResults},
        showVoucherModal: {data: showVoucherModal, set: setShowVoucherModal},
        voucherCode: {data: voucherCode, set: setVoucherCode},
        voucher: {data: voucher, set: setVoucher},
        voucherDetails: {data: voucherDetails, set: setVoucherDetails},
        snackBarLoader: {data: snackBarLoader, set: setSnackBarLoader},
        voucherLoader: {data: voucherLoader, set: setVoucherLoader},

    }
}